import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { IndexFilter } from '../../../../services/properties/schema/IndexFilterSchema';

interface NeedsReviewComponentProps {
    control: Control<IndexFilter>,
    errors: FieldErrors<IndexFilter>
}

const options = [
    { value: '', label: 'All Properties' },
    { value: '1', label: 'Needs Review Only' },
];

const NeedsReviewComponent: React.FC<NeedsReviewComponentProps> = ({ control, errors }) => {
    return (
        <div className='form-group'>
            <label className='form-label'>Billing Type Check</label>
            <Controller
                control={control}
                name='needs_review'
                render={({ field }) => (
                    <Select
                        key={field.value}
                        {...field}
                        className={clsx('', { 'is-invalid': errors.needs_review })}
                        options={options}
                        value={options.find((option) => option.value === field.value)}
                        onChange={(selectedOption) => {
                            if (selectedOption) {
                                field.onChange(selectedOption.value);
                            }
                        }}
                        defaultValue={options[0]}
                    />
                )}
            />
            {errors.needs_review && <div className="invalid-feedback">{errors.needs_review.message}</div>}
        </div>
    )
}

export default NeedsReviewComponent
